export const TEST_ID = 'fullScreenLayout';
